<app-section id="features">
	<span headline i18n="@@features.headerline">Key Features</span>
	<div class="keyfeature row">
		<div class="media">
			<div class="bannerShape realm"></div>
			<div class="media-body" i18n="@@features.unite">
				Unite in a realm with players from all over the world and lead it into the war over territorial control and powerful Orbs.
			</div>
		</div>
		<div class="realmCombined">
			<img src="assets/website/realm_compo.png" style="width: 100%; max-width: 677px;">
		</div>
<!--		<div class="map">
			<div class="mapObject tower0"></div>
			<div class="mapObject tower1"></div>
			<div class="mapObject tower2"></div>
			<div class="mapObject tower3"></div>
			<div class="mapObject crop"></div>
			<div class="mapObject realm"></div>
			<div class="mapObject camp"></div>
			<div class="mapObject resource"></div>
		</div>
		-->
	</div>
	<div class="keyFeatureDivider"></div>
	<div class="keyfeature row">
		<div class="media mediaRight">
			<div class="bannerShape battle"></div>
			<div class="media-body" i18n="@@features.warlords">
				Choose and command mighty warlords and fill their army with your unique setup of troops, to protect your Realm from dangerous intruders, both on the surface and below.
			</div>
		</div>
		<div class="stacked-cards carousel mycards w-100">
			<a class="carousel-control-prev" role="button" (click)="showPrevious()" angulartics2On="click" angularticsAction="previousWarlordButton" angularticsCategory="interactive">
				<span aria-hidden="true" class="carousel-control-prev-icon"></span>
				<span class="sr-only">Previous</span>
			</a>
			<a class="carousel-control-next" role="button" (click)="showNext()" angulartics2On="click" angularticsAction="nextWarlordButton" angularticsCategory="interactive">
				<span aria-hidden="true" class="carousel-control-next-icon"></span>
				<span class="sr-only">Next</span>
			</a>
			<ul>
				<li>
					<img class="d-block" src="assets/warlords/3.png" alt="Merith">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/2.png" alt="Brandoud">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/5.png" alt="Shazeiros">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/13.png" alt="Redspine">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/9.png" alt="Qiralei">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/4.png" alt="Brownbane">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/7.png" alt="Ianceran">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/8.png" alt="Garbaem">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/10.png" alt="Gozzael">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/1.png" alt="Adamar">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/12.png" alt="Nudrum">
				</li>
				<li>
					<img class="d-block" src="assets/warlords/11.png" alt="Romoira">
				</li>
			</ul>
		</div>
		<div class="cardsAlternative">
			<div class="warlordGallery">
				<div class="navigationContainer left">
					<div class="arrow arrow-left" (click)="showPrevGal();" angulartics2On="click" angularticsAction="previousWarlordButton" angularticsCategory="features"></div>
				</div>
				<gallery id="warlordLightbox" [nav]="false" [loadingMode]="'indeterminate'" [loadingStrategy]="'lazy'" angulartics2On="click" angularticsAction="openWarlordButton" angularticsCategory="media"></gallery>
				<div class="navigationContainer right">
					<div class="arrow arrow-right" (click)="showNextGal();" angulartics2On="click" angularticsAction="nextWarlordButton" angularticsCategory="features"></div>
				</div>
			</div>
		</div>
	</div>
	<div class="keyfeature row"></div>
	<div class="keyFeatureDivider"></div>
	<div class="keyfeature row">
		<div class="media">
			<div class="bannerShape discover"></div>
			<div class="media-body" i18n="@@features.discover">
				Discover the lands of Arkheim, its riches and its secrets. Raise an army of Fallen soldiers, harvest the power of the three moons and ascend with your Realm into Eternal Light.
			</div>
		</div>
		<div class="mapCombined text-center w-100">
			<img src="assets/website/map_compo.png" style="width: 100%; max-width: 869px;">
		</div>
		<!--
		<div class="strategy">
			<div class="village"></div>
			<div class="territory"></div>
		</div>
		-->
	</div>
</app-section>
